export const ALPHA_NUMERIC_REGEX = /^[a-z]{1}$/;

export const IGNORE_KEYS = ["enter", "backspace"];
